export interface Account {
  id: string | null;
  firstName: string;
  lastName: string;
  email: string;
  password?: string;
  phone: string;
  active: boolean;
  avatar?: string | null;
  optimizedAvatar?: string | null;
  lastLogin?: Date | null;
  twoFactorEnabled: boolean;
  twoFactorType: string;
  notifyOnNewLogin?: boolean;
  // Direcțiile permise în portalul de client: 'import', 'export' sau 'import,export'
  shippingDirections?: string;
  passwordChangedAt?: Date | null;
  passwordResetCount: number;
  fullName?: string;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  deletedAt?: Date | null;
  accountClients?: AccountClient[];
}

export const defaultAccount: Account = {
  id: null,
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  phone: '',
  active: true,
  avatar: null,
  twoFactorEnabled: false,
  twoFactorType: 'email',
  notifyOnNewLogin: false,
  shippingDirections: 'import',
  passwordResetCount: 0,
  accountClients: [],
};

export interface CreateAccountInput {
  firstName: string;
  lastName: string;
  email: string;
  password?: string;
  phone?: string;
  avatar?: string;
  active?: boolean;
  twoFactorEnabled?: boolean;
  twoFactorType?: string;
  notifyOnNewLogin?: boolean;
  shippingDirections?: string;
  // Clienții atribuiți la creare (obligatoriu pentru cine are doar CLIENT_ACCOUNT_MANAGE_OWN).
  clientIds?: number[];
}

export interface UpdateAccountInput {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  avatar?: string;
  active?: boolean;
  twoFactorEnabled?: boolean;
  twoFactorType?: string;
  notifyOnNewLogin?: boolean;
  shippingDirections?: string;
}

export interface AccountClient {
  id: string;
  accountId: string;
  clientId: number;
  default: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;
}

export interface CreateAccountClientInput {
  accountId: string;
  clientId: number;
  default?: boolean;
}

export interface UpdateAccountClientInput {
  id: string;
  accountId?: string;
  clientId?: number;
  default?: boolean;
}
// Permisiunile paginii Utilizatori → Conturi clienți (oglindă: backend
// client-account-manage-permissions.seeder.ts). „_OWN” = doar conturile ai căror
// clienți îi aparțin toți utilizatorului (client.userId / exportUserId) — verificat în backend.
export const CLIENT_ACCOUNT_MANAGE_ALL = 'CLIENT_ACCOUNT_MANAGE_ALL';
export const CLIENT_ACCOUNT_MANAGE_OWN = 'CLIENT_ACCOUNT_MANAGE_OWN';
export const CLIENT_ACCOUNT_DELETE_ALL = 'CLIENT_ACCOUNT_DELETE_ALL';
export const CLIENT_ACCOUNT_DELETE_OWN = 'CLIENT_ACCOUNT_DELETE_OWN';
export const CLIENT_ACCOUNT_MANAGE_PERMISSIONS = [CLIENT_ACCOUNT_MANAGE_ALL, CLIENT_ACCOUNT_MANAGE_OWN];
export const CLIENT_ACCOUNT_DELETE_PERMISSIONS = [CLIENT_ACCOUNT_DELETE_ALL, CLIENT_ACCOUNT_DELETE_OWN];
export const CLIENT_ACCOUNT_ACCESS_PERMISSIONS = [...CLIENT_ACCOUNT_MANAGE_PERMISSIONS, ...CLIENT_ACCOUNT_DELETE_PERMISSIONS];
